// Client-side key with limited prviliges.
export const KAKAO_JAVASCRIPT_KEY =
  process.env.KAKAO_JAVASCRIPT_KEY ?? "c0c16b591bc50e9c0d8c847bea368ebd";

export const OUTSCHOOL_SERVER = (global as any).OUTSCHOOL_SERVER;
const OUTSCHOOL_TEST_INIT: boolean = !!(global as any).OUTSCHOOL_TEST_INIT;

export const isBrowser = !!OUTSCHOOL_SERVER && !OUTSCHOOL_TEST_INIT;

export const IS_READ_ONLY_MODE = isBrowser
  ? OUTSCHOOL_SERVER.IS_READ_ONLY_MODE
  : process.env.READ_ONLY_MODE === "enabled";
